import { useEffect, useState } from "react";
import axios from "axios";
import { composeApiURL } from "helpers/utility/axiosHelpers";

export const useStartSeed = ({
  datasetId,
  seedId,
  active,
}: {
  datasetId: string;
  seedId: string | null;
  active: boolean;
}) => {
  const [flowId, setFlowId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;

  useEffect(() => {
    if (!active || !datasetId || !seedId) return;

    const start = async () => {
      const startUrl = composeApiURL(
        HOST_URL,
        `/flywheel/${datasetId}/start/${seedId}`,
      );
      try {
        setLoading(true);
        const res = await axios.put(startUrl);
        const returnedFlowId = res.data.flow.id;
        if (!returnedFlowId) {
          throw new Error("No flowId returned from start API");
        }
        setFlowId(returnedFlowId);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    start();
  }, [active, datasetId, seedId, HOST_URL]);

  return { flowId, loading, error };
};
